import React from 'react';
import FaIcon from '../Elements/FaIcon';
import LongText from '../Elements/LongText';


export default class JsxHelper
{
  static CenterDiv (textContent)
  {
    return <div className='text-center'>{textContent}</div>;
  }

  static LeftDiv (textContent)
  {
    return <div className='text-left'>{textContent}</div>;
  }

  static MailTo (email, maxlength = 40)
  {
    return (
      <a
        href={'mailto:' + email}
        target='_blank'
        rel='noopener noreferrer'
      >
        <LongText
          text={email}
          maxLength={maxlength}
        />
      </a>
    );
  }

  static YellowSpan (textContent)
  {
    return <span className='yellow'>{textContent}</span>;
  }

  static Yes (iconclass = 'fa-solid fa-circle-check')
  {
    return (
      <FaIcon
        iconName={iconclass}
        innerClassName='text-green'
      />
    );
  }

  static No (iconclass = 'fa-solid fa-circle-xmark')
  {
    return (
      <FaIcon
        iconName={iconclass}
        innerClassName='text-red'
      />
    );
  }

  static YesNo (value, iconclass)
  {
    return value === true ||
      (value !== null && typeof value !== 'undefined' && value.toString().toLowerCase() === 'true')
      ? JsxHelper.Yes(iconclass)
      : JsxHelper.No(iconclass);
  }

  static OnlyYes (value, iconclass)
  {
    return value === true ||
      (value !== null && typeof value !== 'undefined' && value.toString().toLowerCase() === 'true')
      ? JsxHelper.Yes(iconclass)
      : null;
  }

  static OnlyNo (value, iconclass)
  {
    return value === true ||
      (value !== null && typeof value !== 'undefined' && value.toString().toLowerCase() === 'true')
      ? null
      : JsxHelper.No(iconclass);
  }

  static YesNoReverse (value, iconclass)
  {
    return value === true ||
      (value !== null && typeof value !== 'undefined' && value.toString().toLowerCase() === 'true')
      ? JsxHelper.No(iconclass)
      : JsxHelper.Yes(iconclass);
  }

  static YesNoEmpty (value, yesValue, noValue, iconclass)
  {
    return value === yesValue ? JsxHelper.Yes(iconclass) : value === noValue ? JsxHelper.No(iconclass) : null;
  }

  static Chevron ()
  { //">"
    return (
      <FaIcon
        iconName='fa-solid fa-chevron-right'
        innerClassName='text-green'
      />
    );
  }

  static NonBreakableSpace (count = 1)
  {
    return '\u00a0'.repeat(count);
  }

  static ToRight (content)
  {
    return <div className='text-right'>{content}</div>;
  }
}

